// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { Button, Inline, Stack, Text, textVariants, vars } from '@etg/wings';
import { css, cx, resetButtonStyle } from '@eti/styles';
import { useSiteContext } from '@eti/providers';
import { ConditionalWrapper } from '@eti/components';
import { addAislesToRows, addExitRows, deriveColumnDetailsFromRows, insertAisleGapColumns, isEmptyRow, isExitRow, isRowOverWing } from './cabin/SeatMapCabin.utils';
import { useGetSeatIcons } from '../hooks/useGetSeatIcons';
import { rowItemSize } from '../utils/styles';
import SeatRow from './cabin/SeatRow';
import Wall from './cabin/Wall';
import Wing from './cabin/Wing';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const deckOptionStyles = {
  base: total => css`
    ${resetButtonStyle};
    border-bottom: 2px solid ${vars.colors.inputs.main};
    color: ${vars.colors.text.primary};
    display: flex;
    flex-basis: ${`${100 / total}%`};
    justify-content: center;
    transition:
      background-color 0.2s ease,
      color 0.2s ease;

    &:hover {
      background-color: ${vars.colors.inputs.selected};
    }
  `,
  active: css`
    background-color: ${vars.colors.inputs.selected};
    color: ${vars.colors.inputs.main};
  `
};
const deckWrapperStyles = css`
  min-width: 0;
`;
const cabinLayoutStyles = css`
  height: fit-content;
  overflow-x: auto;
`;
const columnHeaderRowStyles = css`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: fit-content;

  html[dir='rtl'] & {
    flex-direction: row-reverse;
  }
`;
const columnHeaderItemsStyles = css`
  display: flex;

  html[dir='rtl'] & {
    flex-direction: row-reverse;
  }

  & > * {
    margin: 5px 0;

    &:not(:last-child) {
      margin-right: 4px;
    }
  }
`;
const columnLabelStyles = css`
  align-items: center;
  display: flex;
  justify-content: center;
  ${rowItemSize};
`;
const SeatColumnHeader = ({
  details = [],
  isOverWing
}) => /*#__PURE__*/_jsxs("div", {
  className: columnHeaderRowStyles,
  children: [isOverWing && /*#__PURE__*/_jsx(Wing, {
    isLeft: true
  }), /*#__PURE__*/_jsx(Wall, {
    isLeft: true,
    isOverWing: isOverWing
  }), /*#__PURE__*/_jsx("div", {
    className: columnHeaderItemsStyles,
    children: details.map(({
      columnName = ''
    }, index) => /*#__PURE__*/_jsx(Text, {
      className: columnLabelStyles,
      variant: textVariants._14_BOLD,
      children: columnName
    }, `column_${index}`))
  }), /*#__PURE__*/_jsx(Wall, {
    isOverWing: isOverWing,
    isRight: true
  }), isOverWing && /*#__PURE__*/_jsx(Wing, {
    isRight: true
  })]
});
const SeatMapCabinSection = ({
  activeDeck,
  activeSeatAssignments,
  cabins,
  carrier,
  carrierNameLowerCase,
  deckOptions,
  isRyanairInTrip,
  onChange,
  onDeckChange,
  onSkipButtonFocus,
  onSkipButtonHover,
  seatTravelers
}) => {
  const {
    brand
  } = useSiteContext();
  const seatIcons = useGetSeatIcons(brand.code);
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: deckOptions.length > 1,
    wrapper: children => /*#__PURE__*/_jsxs(Stack, {
      className: deckWrapperStyles,
      children: [/*#__PURE__*/_jsx(Inline, {
        "data-testid": "seatMap-deckSelection",
        noWrap: true,
        children: deckOptions.map(option => {
          const isDeckActive = option.value === (activeDeck === null || activeDeck === void 0 ? void 0 : activeDeck.value);
          return /*#__PURE__*/_jsx(Button, {
            "aria-pressed": isDeckActive,
            className: cx(deckOptionStyles.base(deckOptions.length), {
              [deckOptionStyles.active]: isDeckActive
            }),
            onClick: () => onDeckChange(option),
            children: option.label
          }, option.value);
        })
      }), children]
    }),
    children: /*#__PURE__*/_jsx("div", {
      className: cabinLayoutStyles,
      "data-testid": `seatMap-cabinLayout-${carrierNameLowerCase}`,
      id: `seatMap-cabinLayout-${carrierNameLowerCase}`,
      children: cabins.map(({
        rows = [],
        sellSeatMapColumnDetails = []
      }, index) => {
        const effectiveColumnDetails = sellSeatMapColumnDetails.length > 0 ? sellSeatMapColumnDetails : deriveColumnDetailsFromRows(rows);
        if (effectiveColumnDetails.length === 0) {
          return null;
        }
        const columnsWithAisles = insertAisleGapColumns(effectiveColumnDetails);
        const rowsWithAisles = addAislesToRows(rows, columnsWithAisles);
        const transformedRowData = addExitRows(rowsWithAisles);
        return /*#__PURE__*/_jsxs(Stack, {
          "data-testid": "seat-map-cabin",
          spacing: 0,
          children: [/*#__PURE__*/_jsx(SeatColumnHeader, {
            details: columnsWithAisles,
            isOverWing: transformedRowData !== null && transformedRowData !== void 0 && transformedRowData[0] ? isRowOverWing(transformedRowData[0]) : false
          }), transformedRowData === null || transformedRowData === void 0 ? void 0 : transformedRowData.map((row, rowIndex) => {
            var _row$sellSeatMapSeats;
            return /*#__PURE__*/_jsx(SeatRow, {
              activeSeatAssignments: activeSeatAssignments,
              carrier: carrier,
              isEmptyRow: isEmptyRow(row),
              isExitRow: isExitRow(row),
              isOverWing: isRowOverWing(row),
              isRyanairInTrip: isRyanairInTrip,
              onChange: onChange,
              onSkipButtonFocus: onSkipButtonFocus,
              onSkipButtonHover: onSkipButtonHover,
              seatIcons: seatIcons,
              seatTravelers: seatTravelers,
              sellSeatMapSeats: (_row$sellSeatMapSeats = row.sellSeatMapSeats) !== null && _row$sellSeatMapSeats !== void 0 ? _row$sellSeatMapSeats : []
            }, `row_${rowIndex}`);
          })]
        }, `cabin_${index}`);
      })
    })
  });
};
export default SeatMapCabinSection;
//# sourceMappingURL=SeatMapCabinSection.js.map